import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, Input, OnInit, ViewChild, EventEmitter, Output, ElementRef } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { OnDestroy } from 'cv-ng-metadata/core';
import { PointStoreCategoriesService } from '../../../marketplace/admin/services/point-store-categories.service';
import { PointStoreProductEditService } from '../../../marketplace/admin/services/point-store-product-edit.service';
import { PointStoreProductService } from '../../../marketplace/admin/services/point-store-product.service';
import { ValidatorService } from '../../services/validator.service';
import moment from 'moment';
import OverlayScrollbars from 'overlayscrollbars';
import { PointStoreProductEdit } from '../../models/point-store-product-edit.model';

@Component({
  selector: 'cv-point-store-product-information-cxone',
  templateUrl: './cv-point-store-product-information-cxone.component.html',
  styleUrls: ['./cv-point-store-product-information-cxone.component.scss']
})
export class CvPointStoreProductInformationCxoneComponent implements OnInit, OnDestroy {
  @Input() formDataBinding: FormGroup;
  @Output() detectChangesForm: EventEmitter<any> = new EventEmitter();
  @ViewChild("titleInput") titleInput: any; 

  pspes: PointStoreProductEdit = null;
  minDate: Date;
  maxDate: Date;
  pscs: any = null;
  productStart = new Date(); // No specific value, defaults to today.
  productEnd = new Date();
  endDateDisabled = false;
  mode: string;
  categoriesList = [];
  subCategoriesList = [];
  variationTypes: any[] = [];
  categoriesMap: any[] = [];
  diffPrices: boolean;
  unlimitedQuantity: boolean = false;
  priceInputIsEnabled: boolean = true;
  noEndateCheckbox: boolean = false;

  prodInfoOptions: OverlayScrollbars.PartialOptions = {
    scrollbars: {
      visibility: 'visible',
      autoHide: "leave",
      autoHideDelay: 100,
      theme: "custom-scrollbar"
    },
    overflow: {
      x: 'hidden',
      y: 'scroll'
    },
  };

  constructor(private cdr: ChangeDetectorRef,
    private pointStoreProductService: PointStoreProductService,
    private pointStoreCategoriesService: PointStoreCategoriesService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private cvLocalizationFactory: CVLocalizationService,
    private fb: FormBuilder,
    public validatorService: ValidatorService,
    public cvLocalizationService: CVLocalizationService,
    private decimalPipe: DecimalPipe,
    private element: ElementRef
  ) {

  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.initForm();
    this.pscs = this.pointStoreCategoriesService.data;
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.categoriesMap = [...this.pscs.comboBoxCategoryMap];
    this.getCategoriesList();
    this.loadVariationTypesList();
  }

  ngAfterViewInit() {    
    this.productStart = this.validatorService.truncateDate(new Date(), true);
    this.productEnd = this.validatorService.truncateDate(new Date());
    this.fillForm();
    if (this.pspes.copiedProduct) {
      this.formDataBinding.controls['title'].markAsTouched();
    }
  }

  initForm(): void {
    const formControlTitle = new FormControl(null, [this.validatorService.requiredTrimValidator(), this.titleExistsValidator(),this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'title'), Validators.maxLength(50)]);
    this.formDataBinding.addControl('title', formControlTitle);
    const formControlDescription = new FormControl(null,[this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenDescriptionCharacters, 'description'),Validators.maxLength(500)]);
    this.formDataBinding.addControl('description', formControlDescription);
    const formControlDate = new FormControl(this.validatorService.truncateDate(this.productStart, true), [Validators.required]);
    this.formDataBinding.addControl('productStart', formControlDate);
    const formControlDateEnd = new FormControl(this.validatorService.truncateDate(this.productEnd));
    this.formDataBinding.addControl('productEnd', formControlDateEnd);
    const formControlCategory = new FormControl(null, Validators.compose([Validators.required, this.customValidatorForMaxLengthInSource.bind(this), this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'select')]));
    this.formDataBinding.addControl('category', formControlCategory)
    const formControlSubCategory = new FormControl(null, Validators.compose([Validators.required, this.customValidatorForMaxLengthInSource.bind(this), this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'select')]));
    this.formDataBinding.addControl('subCategory', formControlSubCategory)
    const formHasProductVariations = new FormControl(null);
    this.formDataBinding.addControl('hasProductVariations', formHasProductVariations);
    const formControlVariants = new FormArray([]);
    this.formDataBinding.addControl('variants', formControlVariants);
    const formDiffPrices = new FormControl(false);
    this.formDataBinding.addControl('diffPrices', formDiffPrices);
    const formPriceInCoins = new FormControl('', [Validators.required, this.validatorService.upToSevenDigits]);
    this.formDataBinding.addControl('price', formPriceInCoins);
    const formUnlimitedQuantity = new FormControl(false);
    this.formDataBinding.addControl('unlimitedQuantity', formUnlimitedQuantity);
    const formQuantity = new FormControl('', [Validators.required, this.validatorService.upToFiveDigits]);
    this.formDataBinding.addControl('quantity', formQuantity);
    const formDatesValidation = new FormControl(false, [this.validatorService.dateRangeValidator('product_info')]);
    this.formDataBinding.addControl('datesValidation', formDatesValidation);
    //variationType - main form
    const formVariatioName = new FormControl(null,[this.customValidatorForMaxLengthInSource.bind(this),this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'select')]);
    this.formDataBinding.addControl('variationName', formVariatioName);
    this.setInitVariantGroups();
  }

  convertToDate(date) {
    return new Date(date);
  }

  setProductStart(date: Date) {
    let finalStartDate = undefined;
    if (date) {
      if (this.pspes.modifiedPointStoreProduct.ProductEnd && date > this.pspes.modifiedPointStoreProduct.ProductEnd) {
        this.formDataBinding.controls['datesValidation'].setValue(true);
        this.formDataBinding.controls['datesValidation'].markAsTouched();
      } else {
        this.formDataBinding.controls['datesValidation'].setValue(false);
      }
      finalStartDate = this.validatorService.truncateDate(date, true);
    }
    this.pspes.modifiedPointStoreProduct.ProductStart = date ? finalStartDate : null;
    this.pspes.modifiedPointStoreProduct.ProductStart_ForView = !date ? null : moment(finalStartDate).format(CVMomentDateFormat);
    const startDateControl = this.formDataBinding.controls['productStart'];
    startDateControl.setValue(finalStartDate);
    startDateControl.markAsTouched();
    return finalStartDate;
  }

  setProductEnd(date: Date) {
    let finalEndDate = undefined;
    if (date) {
        if (this.pspes.modifiedPointStoreProduct.ProductStart && date < this.pspes.modifiedPointStoreProduct.ProductStart) {
            this.formDataBinding.controls['datesValidation'].setValue(true);
            this.formDataBinding.controls['datesValidation'].markAsTouched();
        } else {
            this.formDataBinding.controls['datesValidation'].setValue(false);
        }
        finalEndDate = this.validatorService.truncateDate(date);
    }
    this.pspes.modifiedPointStoreProduct.ProductEnd = date ? finalEndDate : null;
    this.pspes.modifiedPointStoreProduct.ProductEnd_ForView = !date ? null : moment(finalEndDate).format(CVMomentDateFormat);
    this.formDataBinding.controls['productEnd'].setValue(finalEndDate);
    return finalEndDate;
  }

  getCategoriesList() {
    if (this.categoriesList == null || this.categoriesList.length <= 0) {
      this.categoriesList = this.categoriesMap.map((name, id) => ({ id, name: name.m_Item1 }));
    }
    return this.categoriesList;
  };

  onCategorySelected(item) {
    this.pspes.modifiedPointStoreProduct.Category = item.selected.name;
    this.pspes.modifiedPointStoreProduct.SubCategory = "";
    this.formDataBinding.controls['subCategory'].reset();
    //if the category has subcategories use try, the catch will handle the not variations
    try {
      this.subCategoriesList = this.categoriesMap[item.selected.id].m_Item2.map((name, id) => ({ id, name }));
    } catch (error) {
      this.subCategoriesList = [];
    }
  };

  tempSelectControlValidation(text: string): boolean {
    const tempControl = new FormControl(text);
    const forbiddenCharacters = this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'title');
    return forbiddenCharacters(tempControl) != null;
  }

  onCategoryCreate(e) {
    if (e != null && e.text.length <= 50 && e.text.trimStart() !== "") {
      if (this.tempSelectControlValidation(e.text)) {
        this.formDataBinding.controls['category'].patchValue({ id: this.categoriesList.length, name: e.text.trimStart() });
        this.subCategoriesList = [];
        this.pspes.modifiedPointStoreProduct.Category = null;
      } else {
        //create new temp element with empty subcategory array
        this.categoriesMap.push({ m_Item1: e.text.trimStart(), temp: true, m_Item2: [] });
        this.categoriesMap = [...this.categoriesMap];
        this.categoriesList = this.categoriesMap.map((name, id) => ({ id, name: name.m_Item1, temp: name.temp }));
        this.formDataBinding.controls['category'].patchValue(this.categoriesList[this.categoriesList.length - 1]);
        this.pspes.modifiedPointStoreProduct.Category = e.text;
        this.cleanTempCreatedRecords();
      }
    } else {
      if (e.text.trimStart() === "") {
        this.formDataBinding.controls['category'].patchValue(null);
      } else {
        this.formDataBinding.controls['category'].patchValue({ id: this.categoriesList.length, name: e.text.trimStart() });
      }
      this.subCategoriesList = [];
      this.pspes.modifiedPointStoreProduct.Category = null;
    }
    this.formDataBinding.controls['category'].markAsTouched();
    this.pspes.modifiedPointStoreProduct.SubCategory = "";
    this.formDataBinding.controls['subCategory'].reset();
  }

  onSubCategorySelected(item) {
    this.pspes.modifiedPointStoreProduct.SubCategory = item.selected.name;
  };

  onSubCategoryCreate(e) {
    if (e != null && e.text.length <= 50 && e.text.trimStart() !== "") {
      if (this.tempSelectControlValidation(e.text.trimStart())) {
        this.formDataBinding.controls['subCategory'].setValue({ id: this.subCategoriesList.length, name: e.text.trimStart() });
        this.pspes.modifiedPointStoreProduct.SubCategory = null;
      } else {
        const newID = this.subCategoriesList.length;
        if (newID == 0) {
          this.categoriesMap[this.formDataBinding.controls['category'].value['id']].m_Item2 = [e.text.trimStart()];
        } else {
          this.categoriesMap[this.formDataBinding.controls['category'].value['id']].m_Item2.push(e.text.trimStart());
        }
        this.categoriesMap = [...this.categoriesMap];
        this.subCategoriesList.push({ id: newID, name: e.text });
        this.subCategoriesList = [...this.subCategoriesList];

        //remove the first element and keep the last one in case category is temp
        if (this.categoriesMap[this.formDataBinding.controls['category'].value['id']].temp && this.categoriesMap[this.formDataBinding.controls['category'].value['id']].m_Item2.length > 1) {
          this.categoriesMap[this.formDataBinding.controls['category'].value['id']].m_Item2.shift();
          this.subCategoriesList.shift();
        }
        this.formDataBinding.controls['subCategory'].setValue(this.subCategoriesList[this.subCategoriesList.length - 1]);
        this.pspes.modifiedPointStoreProduct.SubCategory = e.text.trimStart();
      }
    } else {
      if (e.text.trimStart() === "") {
        this.formDataBinding.controls['subCategory'].setValue(null);
      } else {
        this.formDataBinding.controls['subCategory'].setValue({ id: this.subCategoriesList.length, name: e.text.trimStart() });
      }
      this.pspes.modifiedPointStoreProduct.SubCategory = null;
    }
    this.formDataBinding.controls['subCategory'].markAsTouched();
  }

  enableMultipleVariation(event: any): void {
    this.formDataBinding.controls['hasProductVariations'].patchValue(event.checked);
    const pointStoreProductID: number = this.pspes.modifiedPointStoreProduct.PointStoreProductID;
    const modeEditAndProdNoVariation: boolean = (pointStoreProductID !== 0 || this.pspes.copiedProduct) && this.pspes.modifiedPointStoreProduct?.VariationsData?.length === 0;
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    const variantsFormValue = variantsForm.getRawValue();
    if (modeEditAndProdNoVariation) {
      const { VariationsData: initialObjVariation } = this.pointStoreProductService.getNewPointStoreProduct();
      this.pspes.modifiedPointStoreProduct.VariationsData = initialObjVariation;
      this.pspes.originalPointStoreProduct.VariationsData = initialObjVariation;
    } else {
      this.displayLastVariants(variantsFormValue, variantsForm);
    }
    if (event.checked) {
      //add
      this.addRemoveVariantsFormValidators(variantsForm, false);
    } else {
      //remove
      this.addRemoveVariantsFormValidators(variantsForm, true);
    }
    this.validatorService.notifiedVariationChange(true);
  }

  bindingPrice(): void {
    this.pspes.modifiedPointStoreProduct.Price = this.formDataBinding.controls['price'].value;
  }

  bindingQuantity(): void {
    this.pspes.modifiedPointStoreProduct.Quantity = this.formDataBinding.controls['quantity'].value;
  }

  getLocalizationString(key: string, defaultValue: string) {
    return this.cvLocalizationFactory.getCachedText("MarketPlace_Management", key, defaultValue);
  }
  get variantsForm(): FormArray {
    return this.formDataBinding.get('variants') as FormArray;
  }

  setInitVariantGroups() {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    variantsForm.push(this.defaultVariantGroup());
    variantsForm.push(this.defaultVariantGroup());
  }

  defaultVariantGroup() {
    return this.fb.group({
      variationName: [''],
      variationQuantity: [''],
      variationPrice: ['']
    },);
  }

  get isAddVariantValid(): boolean {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    const diffPrices = this.formDataBinding.controls['diffPrices'];

    const validateControlsValue: boolean = variantsForm.controls.every((form: FormGroup) => {
      //if diffPrices is checked then variationPrice control is added to the validation
      const controlsToValidate = Object.values(form.controls).filter((control) => control !== form.get('variationPrice') || (diffPrices && diffPrices.value));
      //check if every control has value
      return controlsToValidate.every((control) => {
        return control.value !== null && control.value !== undefined && control.value?.toString().trim() !== '' || control.disabled;
      })
    });

    return variantsForm.length < 20 && validateControlsValue;
  }

  addNewVariant() {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;

    if (this.isAddVariantValid) {
      variantsForm.push(this.defaultVariantGroup());
      this.cdr.detectChanges();
      this.addNewInputs();
    }
    this.validatorService.notifiedVariationChange(true);
  }

  addNewInputs() {
    this.pspes.modifiedPointStoreProduct.VariationsData[this.pspes.modifiedPointStoreProduct.VariationsData.length] = { "id": this.pspes.modifiedPointStoreProduct.VariationsData.length + 1 };
  }
  get isRemoveVariantValid(): boolean {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    return variantsForm.length > 2;
  }

  removeVariant(index: number) {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    if (this.isRemoveVariantValid) {
      variantsForm.removeAt(index);
      this.removeInputs(index);
    }
    this.validatorService.notifiedVariationChange(true);
  }

  removeInputs(index) {
    this.pspes.modifiedPointStoreProduct.VariationsData.splice(index, 1);
    for (let i = 0; i < this.pspes.modifiedPointStoreProduct.VariationsData.length; i++) {
      this.pspes.modifiedPointStoreProduct.VariationsData[i].id = i + 1;
    }
  }

  getArrayControl(index): FormGroup {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    const formGroup = variantsForm.controls[index] as FormGroup;
    const variationNameControl = formGroup.get('variationName');
    const variantionsQuantityControl = formGroup.get('variationQuantity');

    variationNameControl.setValidators([
    this.validatorService.requiredTrimValidator(),
    this.variantNameValidator(variantsForm, index),
    this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'title'),
    Validators.maxLength(50)
  ]);
  variationNameControl.updateValueAndValidity();
    variantionsQuantityControl.setValidators([  
        Validators.required,
        Validators.min(0),
        this.validatorService.upToFiveDigits
        ]);
    variantionsQuantityControl.updateValueAndValidity();

    if (this.formDataBinding.controls['diffPrices'].value == true) {
      const variantionsPriceControl = formGroup.get('variationPrice');
      variantionsPriceControl.setValidators([Validators.required, this.validatorService.upToSevenDigits]);
      variantionsPriceControl.updateValueAndValidity();
    }

    return formGroup;
  }

  updateVariationQttyControl(value, control: FormGroup) {
    control?.setValue(value);
  }

  variantNameValidator(variantsFormArray: FormArray, currentIndex: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const variantName = control.value.toLowerCase();
      if(!variantName) {
        return null;
      }
      for (let i = 0; i < variantsFormArray.length; i++) {
        if (i !== currentIndex && variantsFormArray.at(i).value.variationName.toLowerCase() === variantName) {
          return { distinct: true };
        }
      }
      return null;
    };
  }

  loadVariationTypesList() {
    this.variationTypes = [...this.pspes.variationTypesList];
  }

  onCreateVariationType(event) {
    if (event != null && event.text.length <= 50 && event.text.trimStart() !== "") {
      if (this.tempSelectControlValidation(event.text.trimStart())) {
        this.formDataBinding.get('variationName').patchValue({ id: this.variationTypes.length, name: event.text.trimStart() });
        this.pspes.modifiedPointStoreProduct.VariationName = null;
      } else {
        const variantTypeId = this.variationTypes.length + 1;
        const newVariantType = { id: variantTypeId, name: event.text.trimStart() };
        this.variationTypes = [...this.variationTypes, newVariantType];
        this.formDataBinding.get('variationName').patchValue(newVariantType);
        this.pspes.modifiedPointStoreProduct.VariationName = event.text.trimStart();
      }
    } else {
      if (event.text.trimStart() === "") {
        this.formDataBinding.controls['variationName'].patchValue(null);
      } else {
        this.formDataBinding.get('variationName').patchValue({ id: this.variationTypes.length, name: event.text.trimStart() });
      }
      this.pspes.modifiedPointStoreProduct.VariationName = null;
    }
    this.formDataBinding.get('variationName').markAsTouched();
  }

  onVariationTypeSelected(item) {
    this.pspes.modifiedPointStoreProduct.VariationName = item.selected.name;
  }

  /**
   * in case the user set some variants display the last values
   * @param values get values for each control
   * @param form formArray
   */
  displayLastVariants(values: any[], form: FormArray) {
    //clear all controls
    form.clear();
    if (values.length > 0) {
      for (let index = 0; index < values.length; index++) {
        //push controls based on the length
        form.push(this.defaultVariantGroup());
      }
      //set values
      form.patchValue(values);
      if (form.touched) {
        //trigger validations
        form.markAllAsTouched();
      }
    }
  }

  setDiffPrices() {
    this.diffPrices = !this.diffPrices;
    this.pspes.modifiedPointStoreProduct.HasVariationPrices = this.diffPrices;
    this.activeDeactivateVariantionPrices(this.diffPrices);
    this.pspes.modifiedPointStoreProduct.HasVariationPrices = this.diffPrices;
  }

  markedUnlimitedQuantity() {
    this.setUnlimitedQuantity(this.unlimitedQuantity);
  }

  addRemoveVariantsFormValidators(variantsForm: FormArray, remove: boolean): void {
    variantsForm.clearValidators();
    this.formDataBinding.controls['variationName'].clearValidators();
    this.formDataBinding.controls['quantity'].clearValidators();
    if (remove) {
      this.formDataBinding.controls['price'].enable();
      this.formDataBinding.controls['variationName'].setValidators([]);
      this.formDataBinding.controls['variationName'].updateValueAndValidity();
      this.formDataBinding.controls['quantity'].setValidators([Validators.required]);
      this.formDataBinding.controls['quantity'].updateValueAndValidity();

      variantsForm.controls.forEach((childForm: FormGroup) => {

        childForm.controls['variationName'].setValidators([]);
        childForm.controls['variationName'].updateValueAndValidity();
        childForm.controls['variationQuantity'].setValidators([]);
        childForm.controls['variationQuantity'].updateValueAndValidity();
        childForm.controls['variationPrice'].setValidators([]);
        childForm.controls['variationPrice'].updateValueAndValidity();

      });
    } else {
      if (this.formDataBinding.controls['diffPrices'].value == true) {
        this.formDataBinding.controls['price'].disable();
        this.formDataBinding.controls['price'].reset();
      } else {
        this.formDataBinding.controls['price'].enable();
      }

      this.formDataBinding.controls['variationName'].setValidators(Validators.compose([Validators.required, this.customValidatorForMaxLengthInSource.bind(this),this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'select')]));
      this.formDataBinding.controls['variationName'].updateValueAndValidity();
      this.formDataBinding.controls['quantity'].setValidators([]);
      this.formDataBinding.controls['quantity'].updateValueAndValidity();

      variantsForm.controls.forEach((childForm: FormGroup) => {

        childForm.controls['variationName'].setValidators([this.validatorService.requiredTrimValidator(), Validators.pattern(this.validatorService.onlyLetterRegex), this.validatorService.distinctVariationName(),this.validatorService.forbiddenCharactersValidator(this.validatorService.forbiddenTitleCharacters, 'title'), Validators.maxLength(50)]);
        childForm.controls['variationName'].updateValueAndValidity();
        childForm.controls['variationQuantity'].setValidators([Validators.required, Validators.min(0), this.validatorService.upToFiveDigits]);
        childForm.controls['variationQuantity'].updateValueAndValidity();

        if (this.formDataBinding.controls['diffPrices'].value == true) {
          childForm.controls['variationPrice'].setValidators([Validators.required, this.validatorService.upToSevenDigits]);
          childForm.controls['variationPrice'].updateValueAndValidity();
        }

      });
      if (variantsForm.touched) {
        //trigger validations
        variantsForm.markAllAsTouched();
      }
    }
    setTimeout(() => {
      this.detectChangesForm.emit();
    }, 0);
  }

  activeDeactivateVariantionPrices(active: boolean): void {
    if (active) {
      //disable and clean the value for the price input
      this.formDataBinding.controls['price'].disable();
      this.formDataBinding.controls['price'].reset();
    } else {
      //enable the price input
      this.formDataBinding.controls['price'].enable();
    }

    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    variantsForm.controls.forEach((childForm: FormGroup) => {
      childForm.controls['variationPrice'].clearValidators();
      if (active) {
        childForm.controls['variationPrice'].setValidators([Validators.required, this.validatorService.upToSevenDigits]);
        childForm.controls['variationPrice'].updateValueAndValidity();
      } else {
        childForm.controls['variationPrice'].setValidators([]);
        childForm.controls['variationPrice'].updateValueAndValidity();
      }
    });
    if (variantsForm.touched) {
      //trigger validations
      variantsForm.markAllAsTouched();
    }
  }

  setUnlimitedQuantity(active: boolean): void {
    const quantityControl = this.formDataBinding.controls['quantity'];
    if (active) {
      quantityControl.disable();
      this.priceInputIsEnabled = false;
      this.pspes.modifiedPointStoreProduct.Quantity = null;
      quantityControl.reset();
      quantityControl.clearValidators();
    } else {
      quantityControl.enable();
      this.priceInputIsEnabled = true;
      quantityControl.setValidators([Validators.required, this.validatorService.upToSevenDigits]);
    }
    quantityControl.updateValueAndValidity();
    if (this.formDataBinding.touched) {
      this.formDataBinding.updateValueAndValidity();
    }
  }

  /**
   * 
   * @param index 
   * @param control 1. variationName, 2. variationPrice, 3. variationQuantity
   */
    updateVariationModelValue(index: number, control: number): void {
        const variantsFormArray = this.formDataBinding.get('variants') as FormArray;
        const variantForm = variantsFormArray.controls[index] as FormGroup;
        const modelControl = this.pspes.modifiedPointStoreProduct.VariationsData[index];

        const controlMapping = {
            1: { key: 'VariationName', controlName: 'variationName', process: (value: string) => value.trim() },
            2: { key: 'VariationPrice', controlName: 'variationPrice' },
            3: { key: 'VariationQuantity', controlName: 'variationQuantity'}
        };

        const controlToUpdate = controlMapping[control];

        if (controlToUpdate) {
            const formControlValue = variantForm.controls[controlToUpdate.controlName].value;
            modelControl[controlToUpdate.key] = controlToUpdate.process ? controlToUpdate.process(formControlValue) : formControlValue;
        }
    }

  private fillForm(): void {

    if (this.pspes.modifiedPointStoreProduct.PointStoreProductID === 0 && !this.pspes.copiedProduct) {
      this.productStart = this.validatorService.truncateDate(new Date(), true);
      this.productEnd = this.validatorService.truncateDate(new Date());
  
      //assign values to the services when the form is opened
      this.pspes.modifiedPointStoreProduct.ProductStart = this.productStart ? this.productStart : null;
      this.pspes.modifiedPointStoreProduct.ProductEnd = this.productEnd ? this.productEnd : null;
      this.pspes.modifiedPointStoreProduct.ProductStart_ForView = !this.productStart ? null : moment(this.productStart).format(CVMomentDateFormat);
      this.pspes.modifiedPointStoreProduct.ProductEnd_ForView = !this.productEnd ? null : moment(this.productEnd).format(CVMomentDateFormat);
      return;
    }

    //Title
    this.formDataBinding.controls['title'].patchValue(this.pspes.modifiedPointStoreProduct.Title);

    //Description
    this.formDataBinding.controls['description'].patchValue(this.pspes.modifiedPointStoreProduct.Description);

    //Available from
    this.productStart = this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.ProductStart, true);
    this.formDataBinding.controls['productStart'].patchValue(this.productStart);

    //Available until
    this.productEnd = this.pspes.modifiedPointStoreProduct.ProductEnd ? this.validatorService.truncateDate(this.pspes.modifiedPointStoreProduct.ProductEnd) : this.pspes.modifiedPointStoreProduct.ProductEnd;
    this.formDataBinding.controls['productEnd'].patchValue(this.productEnd);
    if (!this.productEnd) {
      this.noEndateCheckbox = true;
      this.disableEndDate();
    }

    //category
    const categorySelected = this.categoriesList.find(i => i.name == this.pspes.modifiedPointStoreProduct.Category);
    this.formDataBinding.controls['category'].patchValue(categorySelected);
    this.formDataBinding.controls['category'].markAsTouched();

    if (categorySelected) {
      this.subCategoriesList = this.categoriesMap[categorySelected.id].m_Item2.map((name, id) => ({ id, name }));
      //subcategory
      const subcategorySelected = this.subCategoriesList.find(i => i.name == this.pspes.modifiedPointStoreProduct.SubCategory);
      this.formDataBinding.controls['subCategory'].patchValue(subcategorySelected);
      this.formDataBinding.controls['subCategory'].markAsTouched();
    }

    //multiple products variations
    this.formDataBinding.controls['hasProductVariations'].patchValue(this.pspes.modifiedPointStoreProduct.HasProductVariations);

    //Price in coins
    const price = this.pspes.modifiedPointStoreProduct?.Price;
    const transformedPrice = price ? this.transformNumbers(price) : price;
    this.formDataBinding.controls['price'].patchValue(transformedPrice);

    //Quantity
    const quantity = this.pspes.modifiedPointStoreProduct?.Quantity;
    const transformedQuantity = quantity ? this.transformNumbers(quantity) : quantity;
    this.formDataBinding.controls['quantity'].patchValue(transformedQuantity);

    if(this.pspes.modifiedPointStoreProduct?.Quantity == null){
      this.unlimitedQuantity = true;
      this.markedUnlimitedQuantity();
    }
      
    //Variations
    if (this.pspes.modifiedPointStoreProduct.HasProductVariations) {

      //Variation name.
      this.formDataBinding.get('variationName').patchValue({ id: this.variationTypes.length, name: this.pspes.modifiedPointStoreProduct?.VariationName });
      this.formDataBinding.controls['variationName'].markAsTouched();

      //Different prices for the variants.
      this.formDataBinding.controls['diffPrices'].patchValue(this.pspes.modifiedPointStoreProduct?.HasVariationPrices);
      this.diffPrices = this.pspes.modifiedPointStoreProduct?.HasVariationPrices;
      this.fillVariations();
      this.checkUnlimitedQuantityVariations();
    }
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    this.addRemoveVariantsFormValidators(variantsForm, !this.pspes.modifiedPointStoreProduct.HasProductVariations);
    this.cdr.detectChanges();
  }

  fillVariations(): void {
    let variantsFormArray = this.formDataBinding.get('variants') as FormArray;
    const variantsModelArray = this.pspes.modifiedPointStoreProduct.VariationsData;
    if (variantsModelArray.length > variantsFormArray.length) {
      let differenceOfElements = variantsModelArray.length - variantsFormArray.length;
      for (let index = 0; index < differenceOfElements; index++) {
        variantsFormArray.push(this.defaultVariantGroup());
      }
    }
    for (let index = 0; index < variantsFormArray.length; index++) {
      const variantForm = variantsFormArray.controls[index] as FormGroup;
      let modelControl = variantsModelArray[index];
      variantForm.controls['variationName'].patchValue(modelControl.VariationName);
      variantForm.controls['variationPrice'].patchValue(modelControl.VariationPrice ? this.transformNumbers(modelControl.VariationPrice) : modelControl.VariationPrice);
      variantForm.controls['variationQuantity'].patchValue(modelControl.VariationQuantity ? this.transformNumbers(modelControl.VariationQuantity) : modelControl.VariationQuantity);
      if (modelControl.VariationQuantity == null) {
        this.disableVariantName(index);
      }
    }
  }

  onCategoryDropdownClosed(name: string) {
    const categoryControl = this.formDataBinding.get(name);
    categoryControl.markAsTouched();
  }

  public customValidatorForMaxLengthInSource(control: FormControl) {
    if (control.value != null) {
      if (typeof (control.value) === 'object') {
        if (control.value.name.length > 50) {
          return { maxlength: true };
        }
      }
      else {
        if (control.value.length > 50) {
          return { maxlength: true };
        }
      }
    }
    return null;
  }

  /**
   * store categories where temp = true and is not the current created then
   * remove those elements from the main array
   * update the categoriesList and the category control
   */
  cleanTempCreatedRecords() {
    const tempCategories = this.categoriesMap.filter(category => category?.temp && category.m_Item1 !== this.formDataBinding.get('category').value.name);
    const categoriesFiltered = this.categoriesMap.filter(category => !tempCategories.some(catDelete => catDelete.m_Item1 === category.m_Item1));
    this.categoriesMap = categoriesFiltered;
    this.categoriesList = this.categoriesMap.map((name, id) => ({ id, name: name.m_Item1, temp: name.temp }));
    this.formDataBinding.controls['category'].setValue(this.categoriesList[this.categoriesList.length - 1]);
    this.subCategoriesList = [];
  }

  disableVariantName(index: number) {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    const formGroup = variantsForm.controls[index] as FormGroup;
    const variationNameControl = formGroup.get('variationQuantity');
    let modelControl = this.pspes.modifiedPointStoreProduct.VariationsData[index];
    const isDisabled = variationNameControl.disabled;
    if (isDisabled) {
      variationNameControl.enable();
      modelControl.VariationQuantity = '';
    } else {
      variationNameControl.reset();
      modelControl.VariationQuantity = null;
      variationNameControl.disable();
    }
  }

  titleExistsValidator(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: any} | null => {
        if(this.pspes?.collection?.originalData == null) {
            return null;
        }
        const titleExists = this.pspes.collection.originalData.some(item => item.Title?.toLowerCase()?.trim() === control.value?.toLowerCase()?.trim() && this.isDifferentProduct(item));
        return titleExists ? { 'titleExists': {value: control.value} } : null;
    };
  }

  isDifferentProduct(item: any): boolean {
    let isDifferent: boolean;
    isDifferent = this.pspes.modifiedPointStoreProduct.PointStoreProductID !== item.PointStoreProductID;
    return isDifferent;
  }

  disableEndDate() {
    const endDateControl = this.formDataBinding.get('productEnd');
    const isDisabled = endDateControl.disabled;
    if (isDisabled) {
      endDateControl.enable();
      this.endDateDisabled = false;
      this.productStart = this.validatorService.truncateDate(this.productStart, true);
      this.productEnd = this.productEnd ? this.productEnd : this.validatorService.truncateDate(this.productStart);
      this.pspes.modifiedPointStoreProduct.ProductEnd = this.productEnd;
      this.pspes.modifiedPointStoreProduct.ProductEnd_ForView = moment(this.productEnd).format(CVMomentDateFormat);
      const inputElement = this.element.nativeElement.querySelector('#dpProductEnd');
      setTimeout(function() {
          inputElement.removeAttribute('readonly');
      }, 10);
    } else {
      endDateControl.reset();
      endDateControl.disable();
      this.formDataBinding.controls['datesValidation'].setValue(false);
      this.productEnd = null;
      this.endDateDisabled = true;
      this.pspes.modifiedPointStoreProduct.ProductEnd = null;
      this.pspes.modifiedPointStoreProduct.ProductEnd_ForView = null;
    }
  }

  getControlFromArray(index: number, control: string): AbstractControl {
    const variantsForm = this.formDataBinding.get('variants') as FormArray;
    const formGroup = variantsForm.controls[index] as FormGroup;
    const variationNameControl = formGroup.get(control);
    return variationNameControl;
  }

  trimVariantName(i: number, trimValue?: boolean) {
    const variantName: HTMLInputElement = document.querySelector("#variationName" + i + " div input");
    variantName.value = trimValue? variantName.value.trim() : variantName.value.trimStart(); 
    const variantsFormArray = this.formDataBinding.get('variants') as FormArray;
    const variantForm = variantsFormArray.controls[i] as FormGroup;
    variantForm.controls['variationName'].setValue(variantName.value);
  }

  validateClipboardInput(event: ClipboardEvent, control: AbstractControl): void {
    event.preventDefault();
    const pastedContent = event.clipboardData.getData('text');
    let sanitizedContent = pastedContent.replace(/[^\d,]/g, '');
    let digitsOnly = sanitizedContent.replace(/,/g, '');
    if (digitsOnly.length > 5) {
        digitsOnly = digitsOnly.substring(0, 5);
    }
    digitsOnly = this.decimalPipe.transform(parseFloat(digitsOnly), undefined, CVCultureName);
    setTimeout(() => {
        digitsOnly = digitsOnly.replace(/^0+/, ''); // Remove leading zeros
        control.setValue(digitsOnly);
    }, 0);
  }

  private checkUnlimitedQuantityVariations(): void {
    setTimeout(() => {
      let index: number = 0;
      for (const variant of this.pspes.modifiedPointStoreProduct.VariationsData) {
        if (variant.VariationQuantity == null) {
          const checkboxUnlimitedQuantity: any = document.querySelector(`#cxone-checkbox-unlimited-quantity-variation${index} div div input`);
          checkboxUnlimitedQuantity.checked = true;
        }
        index++;
      }
    }, 0);
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.formDataBinding.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  private transformNumbers(value: string | number): string {
    return this.decimalPipe.transform(value, undefined, CVCultureName);
  }

  get forbiddenCharactersMessage(): string {
    let forbiddenMsg = `${this.cvLocalizationService.getCachedText('MarketPlace_Management_Messages', 'Cannot_Use', 'Cannot use')} {0}`;      
    return forbiddenMsg.replace('{0}', this.validatorService.forbiddenTitleCharacters.join(' '));
  }
}
